export default {
    translation: {
		actions: 'Actions',
		angle: 'Angle',
		appName: 'Robokids Online',
		backgroundColor: 'צבע רקע',
		backToHomepage: 'בחזרה לעמוד הבית',
		blockProperties: 'מאפיינים',
		blueTooth: 'בלוטוס',
		checkAnswer: 'בדוק את התשובה',
		checkEmailBox: 'בדוק את תיבת הדואר האלקטרוני שלך.',
		color: 'Color',
		communication: 'תקשורת',
		confirmPassword: 'אשר סיסמה',
		connect: 'התחבר',
		connected: 'מחובר',
		correctlyAnswer: 'תשובה נכונה',
		courseImage: 'Course image',
		courses: 'Courses',
		description: 'תיאור',
		devicesList: 'רשימת התקנים',
		direction: 'Direction',
		disconnect: 'התנתק',
		downloadToRobot: 'הורד לרובוט',
		doYouWantSave: 'יצירת תכנה חדשה תמחוק את הישנה. האם לשמור?',
		email: 'דוא"ל',
		emailAlreadyExists: 'האימייל כבר קיים',
		emailHasBeenSent: 'דוא"ל נשלח!',
		emailHasNotBeenSent: 'האימייל לא נשלח!',
		en: 'English',
		zh: 'Korean',
		error: 'שגיאה',
		files: 'Files',
		finished: 'Finished',
		finishTopic: 'Finish topic',
		forgotPassword: 'שכחת את הסיסמא?',
		he: 'עברית',
		help: 'עזרה',
		home: 'Home',
		homepage: 'דף הבית',
		id: 'Id',
		image: 'Image',
		language: 'שפה',
		languageDoYouWantSave: 'שינוי השפה ימחק את התכנה שלך. האם לשמור?',
		lesson_image: 'Lesson image',
		lessons: 'Lessons',
		level: 'רמת קושי',
        level1: 'קטנטנים',
        level2: 'מתחילים',
        level3: 'מתקדמים',
        level4: 'מקצוענים',
        level5: 'מומחים',
		list: 'List',
		login: 'התחברות',
		logout: 'להתנתק',
		name: 'שם',
		no: 'לא',
		notFoundText: 'לא הצלחנו למצוא את הדף שאתה מחפש.',
		notFoundTitle: '404 הדף לא נמצא',
		notStarted: 'Not started',
        numberOfDaysBeforeLesson: 'Number of days before opening lesson',
		online: 'באינטרנט',
		openOurSite: 'פתח את האתר שלנו',
		password: 'סיסמה',
		passwordHasBeenChanged: 'הסיסמא שונתה',
		port: 'Port',
        prerequisiteCourses: 'Prerequisite courses',
		profile: 'הפרופיל שלי',
		register: 'הירשם',
		resetFilters: 'Reset filters',
		resetPassword: 'לאפס את הסיסמה',
		saveResult: 'שמור את התוצאה',
		scanDevices: 'סרוק',
		search: 'Search',
		searchFor: 'Search for',
		sendPasswordResetLink: 'שלח קישור לאיפוס סיסמה',
		settings: 'הגדרות',
		siteMessage: 'הודעת אתר',
		sound: 'Sound',
		sourceCode: 'קוד מקור',
		speed: 'Speed',
		started: 'Started',
		status: 'Status',
		success: 'הצלח',
		terminal: 'מסוף',
		topic: 'נושא',
		topicContent: 'Topic Content',
		topicImage: 'Topic image',
		topicQuizzes: 'Topic quizzes',
		topics: 'נושאים',
		topicVideo: 'Topic Video',
		tryAgain: 'נסה שוב.',
        updateSystem: 'עדכון מערכת ההפעלה בבקר',
		usb: 'USB',
		userNotExistCredentials: 'המשתמש שצוין אינו קיים.',
		workspace: 'מרחב עבודה',
		yes: 'כן',
		youDidNotPassTheQuizzes: 'יש לענות על השאלות נכונה כדי להתקדם',
		youSpentLittleTimeWatchingContent: 'יש להקדיש יותר זמן לשיעור זה',
        version: 'גירסה',
        ////MainPage
        mainPageTitleOnlineRobotic: 'ללמוד, לבנות, לתכנת, ליהנות',
        mainPageTitleAdventurersKids: 'הרפתקאות רובוקידס',
        mainPageButtonCoursesList: 'לרשימת ההרפתקאות',
        mainPageButtonSignInUp: 'התחברות | הרשמה',
        mainPageContentTitle: 'ההרפתקאות שלנו',
        buttonStartAdventure: 'צא להרפתקאה',
        paginationShowMore: 'הצג עוד...',
        programMyRobot: 'תכנת את הרובוט',
        //Pop-up
        notification: 'הודעות',
        newBadge: 'תג חדש',
        youReceivedANewBadge: 'קיבלת תג חדש!',
        newCertificate: 'תעודה חדשה',
	    youReceivedANewCertificate: 'קיבלת תעודה חדשה!',
        selectPicture: 'בחירת תמונה',
        apply: 'אישור',
        uploadPicture: 'העלאת תמונה',
        signIn: 'התחברות',
        signUn: 'הרשמה',
        forgotMyPassword: 'שכחתי את הסיסמא',
        doNotHaveAccount: "אין לכם חשבון?",
        myProfile: 'הפרופיל שלי',
        about: 'אודות',
        back: 'חזור',
        signOut: 'התנתקות',
        passwordRecovery: 'שיחזור סיסמא',
        passwordReset: 'איפוס סיסמא',
        userName: 'שם משתמש',
        yourEmail: 'כתובת המייל שלך',
        signUp: 'הרשמה',
        noInternet: 'אין חיבור לאינטרנט',
        connectToInternet: 'התחבר לאינטרנט',
        passwordConfirmation: 'אישור סיסמא',
        
		//lessonsPage
        btnContinue: 'המשך...',
        whatWillLearn: 'מה בהרפתקאה?',
        join: 'מידע',
        hours: 'שעות',
        graduated: 'בוגרים',
        video: 'סרטונים',
        developingSkills: 'פיתוח יכולות',
        courseBadges: 'תגי רובוקידס',
        moreAdventurersCourses: 'הרפתקאות נוספות שלנו',
        learnMoreRobots: 'Learn to Move a Robots',
        news: 'מה חדש?',
        //dashboard
        activeCourses: 'הרפתקאות פעילות',
        courseCompleted: 'הרפתקאות שסיימת',
        lessonsCompleted: 'שיעורים שסיימת',
        skillsAcquired: 'יכולות שצברת',
        badges: 'תגים',
        certificates: 'תעודות',
        moreAdventurersForYou: 'הרפתקאות נוספות עבורך',
        //topic
        filesAndTools: 'קבצים וכלים',
        yourMission: 'המשימה שלך',
        quiz: 'מבדק',
        launchProgram: 'סביבת תכנות',
        complete: 'סיום',
        sendAnswers: 'שלח תשובות',
        wrongQuizAnswer: 'ישנן תשובות שגויות, אנא נסו שוב',
        correctQuizAnswer: 'כל הכבוד!',
        quizPassed: 'סיימתם את הבדיקה בהצלחה',
        welcome: 'welcome',
        guest: 'guest',
        willBeAvailable: 'יהפוך לזמין',
        willBeAvailableIn: 'יהפוך לזמין בעוד',
        days: 'ימים ',
        unlockLevel: 'שיעור נעול',
        pleaseInsertThePassword: 'נא להזין סיסמא',
	    submit: 'Submit',
        close: 'Close',
        invalidPassword: 'הסיסמא שגויה, אנא נסו שוב',
        robokidsAndventures: 'הרפתקאות רובוקידס',
        studentDashboard: 'לוח הבקרה',
        inTheLessonThereAreNoTopics: 'in the lesson there are no topics',
        courseMapTitle: 'מפת התקדמות',
        iWantProgram: 'I want to program my robot',
        afterPreviousLessonCompletion: 'לאחר סיום השיעורים הקודמים',
        rotateYourDevice: 'נא לסובב את המכשיר',
        downloading: 'הורדה לרובוט',
        errorDownloading: 'שגיאת הורדה',
        scanningForRobots: 'סורק אחר רובוטים',
        joyStick: 'גוייסטיק',
        pleaseAnswerTheQuizQuestions: 'נא לענות על כל השאלות',
        mainPageDescription: 'Golanix offers an adventure combined with learning code. we have large variety of courses for tournaments drives players to take the most desirable actions towards becoming a code.',
	    joystickNippleSettings: 'הגדרת ידית גוייסטיק',
        joystickLeftNipple: 'שמאלית',
        joystickRightNipple: 'ימנית',
        projectDoYouWantSave: 'פעולה זו תאפס את העבודה שלך. האם ברצונך לשמור?',
    },
};



// WEBPACK FOOTER //
// ./src/lang/he/he.js